import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
    Box,
    Text,
    Button,
    List, ListItem,
    HStack,
    Stack,
    Radio,
} from '@chakra-ui/react'
import { Reorder } from "framer-motion";

import { toast } from "react-toastify";

import {
    Formik,
    Form,
} from 'formik';
import { RadioGroupControl } from 'formik-chakra-ui';
import { RxCaretSort } from 'react-icons/rx';
import { fetchWrapper } from '../../../helpers';
import CheckboxInput from '../../../components/form/CheckboxInput';
import { SelectField } from '../../../components/form';
import { getChannelLabel } from '../../../utils/channels';


function Marketing({ customer_id, message_type_id, channelData, editPermission }) {
    const [loading, setLoading] = useState(false);
    const [channelList, setChannelList] = useState([])
    const [channelListOrg, setchannelListOrg] = useState([])
    const [methodData, setMethodData] = useState([])

    const [channelListDropDown, setChannelListDropDown] = useState([])

    useEffect(() => {

        loadRouteMethod()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer_id, message_type_id])

    const [formData, setFormData] = useState({
        message_type_id: message_type_id,
        customer_id: customer_id,
        method: 'smart',
        sent_other_channel: '',
        sent_other_channel_id: '',
        custom_route_order: ''

    });
    const loadRouteMethod = async () => {
        setLoading(true)
        const url = `${process.env.REACT_APP_API_URL}/route_method/list-by-customer?message_type_id=${message_type_id}`;
        const data = await fetchWrapper.get(url)
        //loadList(data.channel_list);
        if (data.data) {

            setFormData({
                message_type_id: message_type_id,
                customer_id: customer_id,
                method: data.data.method,
                sent_other_channel: data.data.sent_other_channel == 1 ? true : false,
                sent_other_channel_id: data.data.sent_other_channel_id,
                custom_route_order: ''

            })

            if (data.data.method === 'custom') {

                const savedValue = JSON.parse(data.data.custom_route_order);

                const orgValue = data.channel_list;

                // Step 1: Filter out items in savedValue that are not in orgValue
                const orgIds = orgValue.map(item => item.id);
                let updatedSavedValue = savedValue.filter(item => orgIds.includes(item.id));

                // Step 2: Add items from orgValue that don't exist in updatedSavedValue
                orgValue.forEach(orgItem => {
                    if (!updatedSavedValue.some(savedItem => savedItem.id === orgItem.id)) {
                        updatedSavedValue.push({ id: orgItem.id, name: orgItem.name });
                    }
                });



                setChannelList(updatedSavedValue);
            } else {
                setChannelList(data.channel_list)
            }

        } else {

            setFormData({
                message_type_id: message_type_id,
                customer_id: customer_id,
                method: 'smart',
                sent_other_channel: '',
                sent_other_channel_id: '',
                custom_route_order: ''

            })

            setChannelList(data.channel_list)

        }
        setMethodData(data.data)



        setLoading(false)
        loadList(data.channel_list)

    }

    const loadList = async (list) => {


        const listValue = list.map(cRs => {
            return { id: cRs.id, name: cRs.name }
        })


        setChannelListDropDown({ data: listValue });


    }



    const FormSchema = Yup.object().shape({
        // method: Yup.string().required('Required'),


    });







    const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

        let data = values
        let url = `${process.env.REACT_APP_API_URL}/route_method/create`;
        if (methodData) {
            url = `${process.env.REACT_APP_API_URL}/route_method/update`;
            data.id = methodData.id
        }


        const custom_route_order = channelList
        if (data.method === 'custom') {
            data.custom_route_order = custom_route_order

        }


        if (!data.sent_other_channel) {
            data.sent_other_channel_id = 0;
        }


        await fetchWrapper.post(url, data)

        toast(`Record has been saved `, {
            type: "info"
        });
    }

    const typeList = [
        { id: 'smart', name: 'Smart Routing', description: "Smart Routing identifies the most cost-effective communication channel by evaluating the notification’s price and destination country, ensuring optimal cost and delivery efficiency." },

    ]
    const typeListCustom = [
        { id: 'custom', name: 'Custom Routing', description: "Custom Routing enables customers to configure notification paths based on the type of notification. In the event of a failure, the system automatically reroutes the notification to the next preferred channel, ensuring seamless and reliable delivery." },

    ]
    return (




        <Formik
            enableReinitialize
            validationSchema={FormSchema}
            initialValues={formData}
            onSubmit={onSubmit}
        >
            {({
                setFieldValue,
                setFieldTouched,
                values,
                errors,
                touched,
            }) => (

                <Form>

                    <Box mb={3}>
                        <RadioGroupControl name="method" defaultValue="smart">
                            <Stack spacing={3} direction="column">
                                {typeList.map((type) => {
                                    const isSelected = values.method === type.id;
                                    return (
                                        <Box
                                            key={type.id}
                                            onClick={() => setFieldValue('method', type.id)}
                                            cursor="pointer"
                                            borderWidth="1.5px"
                                            borderColor={isSelected ? 'var(--brand-primary)' : 'gray.200'}
                                            bg={isSelected ? 'rgb(var(--brand-primary-rgb) / 0.04)' : 'white'}
                                            borderRadius="lg"
                                            px={4}
                                            py={3}
                                            transition="all 0.15s ease"
                                            _hover={{ borderColor: isSelected ? 'var(--brand-primary)' : 'gray.300' }}
                                        >
                                            <Radio value={type.id} colorScheme="brand">
                                                <Text fontWeight="600" fontSize="sm" color="gray.800">{type.name}</Text>
                                            </Radio>
                                            <Text fontSize="sm" color="gray.500" ml={6} mt={1}>
                                                {type.description}
                                            </Text>
                                        </Box>
                                    );
                                })}
                            </Stack>
                        </RadioGroupControl>
                    </Box>

                    <Box mb={3}>
                        <RadioGroupControl name="method" defaultValue="smart">
                            <Stack spacing={3} direction="column">
                                {typeListCustom.map((type) => {
                                    const isSelected = values.method === type.id;
                                    return (
                                        <Box
                                            key={type.id}
                                            onClick={() => setFieldValue('method', type.id)}
                                            cursor="pointer"
                                            borderWidth="1.5px"
                                            borderColor={isSelected ? 'var(--brand-primary)' : 'gray.200'}
                                            bg={isSelected ? 'rgb(var(--brand-primary-rgb) / 0.04)' : 'white'}
                                            borderRadius="lg"
                                            px={4}
                                            py={3}
                                            transition="all 0.15s ease"
                                            _hover={{ borderColor: isSelected ? 'var(--brand-primary)' : 'gray.300' }}
                                        >
                                            <Radio value={type.id} colorScheme="brand">
                                                <Text fontWeight="600" fontSize="sm" color="gray.800">{type.name}</Text>
                                            </Radio>
                                            <Text fontSize="sm" color="gray.500" ml={6} mt={1}>
                                                {type.description}
                                            </Text>

                                            {values.method === 'custom' && (
                                                <Box mt={3} pt={3} ml={6} borderTopWidth="1px" borderColor="gray.100" onClick={(e) => e.stopPropagation()}>
                                                    <Text fontSize="xs" color="gray.500" mb={3}>
                                                        Drag and drop to rearrange the fallback order
                                                    </Text>

                                                    <List
                                                        as={Reorder.Group}
                                                        initial={false}
                                                        axis="y"
                                                        values={channelList}
                                                        onReorder={setChannelList}
                                                        spacing={2}
                                                    >
                                                        {channelList?.map((item) => (
                                                            <ListItem
                                                                as={Reorder.Item}
                                                                key={item.id}
                                                                value={item}
                                                                px={3}
                                                                py={2.5}
                                                                mb={2}
                                                                borderWidth="1px"
                                                                borderColor="gray.200"
                                                                borderRadius="lg"
                                                                bg="white"
                                                                display="flex"
                                                                justifyContent="space-between"
                                                                alignItems="center"
                                                                cursor="grab"
                                                                transition="all 0.15s ease"
                                                                _hover={{ borderColor: 'gray.300', shadow: 'sm' }}
                                                            >
                                                                <HStack spacing={1.5}>
                                                                    <Box color="gray.400" display="flex">
                                                                        <RxCaretSort size={20} />
                                                                    </Box>
                                                                    <Text fontSize="sm" fontWeight="500" color="gray.800">{getChannelLabel(item.name)}</Text>
                                                                </HStack>

                                                                <Text fontSize="xs" color="gray.400" fontWeight="500">
                                                                    Fixed Cost Globally
                                                                </Text>
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                </Box>
                                            )}
                                        </Box>
                                );
                            })}
                        </Stack>
                    </RadioGroupControl>
                </Box>

                <Box mb={3} px={4} py={3} borderWidth="1px" borderColor="gray.200" borderRadius="lg" bg="gray.50">
                    <CheckboxInput title="Also send this Notification to" name="sent_other_channel" style={{ fontWeight: "600" }} />
                    <Text fontSize="xs" color="gray.500" ml={6} mt={1}>
                        In addition to the primary notification, this will also be sent through the specified channel, triggering notifications across two channels simultaneously.
                    </Text>

                    {values.sent_other_channel &&
                        <Box mt={3} ml={6}>
                            <SelectField name="sent_other_channel_id" list={channelListDropDown} title="Channel List" />
                        </Box>
                    }
                </Box>

                <HStack justify="flex-end" mb={4}>
                    <Button
                        size="sm"
                        color="#fff" bg="var(--brand-primary)"
                        fontFamily="'Lato', sans-serif"
                        borderRadius="lg"
                        _hover={{ bg: 'var(--brand-primary-hover)' }}
                        _active={{ bg: 'var(--brand-primary-active)' }}
                        transition="background 0.15s ease"
                        type='submit'
                        isDisabled={!editPermission}
                    >
                        Update Settings
                    </Button>
                </HStack>
            </Form>
            )}
        </Formik>


    )
}

export default Marketing;
